'use client';

import React from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import classNames from 'classnames';
import s from './SimpleColumnChart.module.scss';

const SimpleColumnChart = ({
    title = 'Chart title not set',
    displayLargeTitle = false,
    xAxisLabel = '',
    yAxisLabel = '',
    series = [],
}) => {
    const chartTitleCls = classNames(s.ChartTitle, {
        [s['ChartTitle--Large']]: displayLargeTitle,
    });

    const xCategories = series?.[0]?.data?.map((d) => d.name) || [];

    const fontSize = { fontSize: '10px' };

    const options = {
        chart: { type: 'column' },
        title: { text: null },
        xAxis: {
            categories: xCategories,
            title: { text: xAxisLabel, style: fontSize },
            labels: { style: fontSize },
        },
        yAxis: {
            title: { text: yAxisLabel, style: fontSize },
            labels: { style: fontSize },
        },
        legend: { itemStyle: fontSize },
        series: series.map((serie) => ({
            name: serie.name,
            data: serie.data.map((d) => d.y),
            color: '#194C7A',
        })),
        credits: { enabled: false },
    };

    return (
        <div className={s.Root}>
            <div className={s.ChartHeader}>
                <h3 className={chartTitleCls}>{title}</h3>
            </div>
            <div className={s.ChartContainer}>
                <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
        </div>
    );
};

SimpleColumnChart.propTypes = {
    title: PropTypes.string,
    displayLargeTitle: PropTypes.bool,
    xAxisLabel: PropTypes.string,
    yAxisLabel: PropTypes.string,
    series: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            data: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string,
                    y: PropTypes.number,
                })
            ),
        })
    ),
};

export default SimpleColumnChart;
